var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { DynamicTooltip } from "./DynamicTooltip";
import { TooltipText } from "./TooltipText";
export function withTooltip(ttProps) {
    return function (X) { return function (props) { return (React.createElement(TooltipText, __assign({}, ttProps),
        React.createElement(X, __assign({}, props)))); }; };
}
export function withDynamicTooltip(ttProps) {
    return function (X) { return function (props) { return (React.createElement(DynamicTooltip, __assign({}, ttProps),
        React.createElement(X, __assign({}, props)))); }; };
}



//////////////////
// WEBPACK FOOTER
// ./src/features/tooltip/withTooltip.tsx
// module id = 1136
// module chunks = 3